import React, { useState, useEffect } from "react";

const ResetLink = () => {
  const [email, setEmail] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(300);
  const [message, setMessage] = useState("email sent");
  const [placeholder, setPlaceholder] = useState("Enter your email");
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    let timer;

    if (resendDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((countdown) => countdown - 1);
      }, 1000);
    }
    if (countdown === 0) {
      setResendDisabled(false);
    }

    return () => clearInterval(timer);
  }, [resendDisabled, countdown]);

  const handleResetLink = () => {
    // Add your logic to resend the email
    setResendDisabled(true);

    // Start the countdown timer
    setCountdown(300);

    setTimeout(() => {
      setResendDisabled(false);
    }, 60000);
  };

  // const handlemailResponse
  const handleEmailSubmit = (e) => {
    e.preventDefault();
    setResendDisabled(true);
    setPlaceholder(email);
    setEmail("");
    setMessage("");
    setDisable(true);
  };

  return (
    <div className="flex justify-center ">
      <div className="w-[70%]  mx-auto mt-8 p-6  shadow-md rounded-md">
        <h2 className="text-2xl font-semibold mb-4 text-black items-center">
          Send Reset Link
        </h2>

        <form onSubmit={handleEmailSubmit}>
          <input
            className="mb-4 w-full p-2  border rounded-md"
            type="email"
            placeholder={placeholder}
            value={email}
            required="true"
            disabled={disable}
            onChange={(e) => setEmail(e.target.value)}
          />
          {resendDisabled && <p className="p-2 text-red-500">{message}</p>}
          <button
            type="submit"
            className="bg-blue-500  text-white px-4 py-2 my-2 rounded-md"
            disabled={resendDisabled}
          >
            Send reset link
          </button>
        </form>

        {resendDisabled && (
          <p className="text-sm">Link expires in {countdown} seconds</p>
        )}
      </div>
    </div>
  );
};

export default ResetLink;
